import React from "react";
import { Modal, Button, Row, Col } from "react-bootstrap";
import { Eye, Download } from "react-bootstrap-icons";
import './TaskModal.css';
import { IoCheckmark, IoClose } from "react-icons/io5";

const TaskModal = ({ show, onHide, taskData, fileData }) => {
  const {
    taskId,
    caseId,
    priority,
    status,
    category,
    type,
    subtype,
    targetDate,
    remarks,
    assignedTo,
    createdBy,
    createdAt,
    updatedAt,
  } = taskData;

  const { fileName, fileSize, fileType } = fileData;

  // Choose label dynamically
  const fileSectionTitle =
    category?.toLowerCase().includes("video")
      ? "Video"
      : category?.toLowerCase().includes("image")
      ? "Image"
      : "Document";

  return (
    <Modal show={show} onHide={onHide}  size="lg" className="task-modal" dialogClassName="custom-modal-width">
      <Modal.Body>

        {/* HEADER */}
        <div className="d-flex justify-content-between align-items-start mb-3">
          <div>
            <div className="d-flex align-items-center gap-3">
                <h5 className="fw-bold">{taskId}</h5>
                {/* TAGS */}
                <div className="d-flex gap-2">
                    <span className="badge bg-danger text-uppercase">{priority}</span>
                    <span className="badge bg-success text-uppercase">{status}</span>
                </div>
            </div>
            <small className="text-muted">Case ID: {caseId}</small>
          </div>

          <button className="btn btn-link text-dark fs-4" onClick={onHide}>
            ×
          </button>
        </div>

        {/* DETAILS GRID */}
        <Row className="mb-4">
          <Col md={6}>
            <div className="label">Category</div>
            <div className="value">{category}</div>
          </Col>

          <Col md={6}>
            <div className="label">Type</div>
            <div className="value">{type}</div>
          </Col>

          <Col md={6} className="mt-3">
            <div className="label">Subtype</div>
            <div className="value">{subtype}</div>
          </Col>

          <Col md={6} className="mt-3">
            <div className="label">Target Date</div>
            <div className="value">{targetDate}</div>
          </Col>
        </Row>

        {/* REMARKS */}
        <div className="section-title mb-1">Remarks from Admin</div>
        <p className="text-muted">{remarks}</p>

        <hr />

        {/* FILE SECTION */}
        {fileData && <><div className="section-title mb-2">{fileSectionTitle}</div>

        <div className="document-box d-flex justify-content-between align-items-center p-3">
          <div>
            <div className="fw-semibold">{fileName}</div>
            <div className="text-muted small">{fileSize}</div>
          </div>

          <div className="d-flex gap-2">

            {/* Eye icon only if preview is allowed */}
            {["image", "video"].includes(fileType) && (
              <Button variant="light" className="icon-btn">
                <Eye size={20} />
              </Button>
            )}

            <Button variant="light" className="icon-btn">
              <Download size={20} />
            </Button>
          </div>
        </div></>}

        <hr />

        {/* FOOTER DETAILS */}
        <Row className="mt-3 mb-4">
          <Col md={6}>
            <div className="label">Assigned To</div>
            <div className="value">{assignedTo}</div>
          </Col>

          <Col md={6}>
            <div className="label">Created By</div>
            <div className="value">{createdBy}</div>
          </Col>

          <Col md={6} className="mt-3">
            <div className="label">Created At</div>
            <div className="value">{createdAt}</div>
          </Col>

          <Col md={6} className="mt-3">
            <div className="label">Updated At</div>
            <div className="value">{updatedAt}</div>
          </Col>
        </Row>

        {/* BUTTONS */}
        <div className="d-flex justify-content-between mt-12">
          <Button variant="danger" className="px-4">
            <IoClose /> Redo
          </Button>
          <Button variant="success" className="px-4">
            <IoCheckmark/> Approve
          </Button>
        </div>

      </Modal.Body>
    </Modal>
  );
};

export default TaskModal;
